import React from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { dashboardListSelector, hasChangedMapSelector } from '@store/tempDashboard/selectors';
import { compareTabsSelector } from '@store/dashboards/tabs/selectors';
import { selector as commonSelector } from '@store/common';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import * as tabsActions from '@store/dashboards/tabs/actions';
import {
  changeSaveDashboardPromptVisibility,
  toggleUpdatePopupVisible,
  setActiveDashboardId,
} from '@store/dashboards/ui/actions';
import { selectors as sharedTabsSelector } from '@store/sharedTabs';
import TemporaryDashboardTabs from './TemporaryDashboardTabs';

// Define types for Redux props that this component receives
interface ReduxProps {
  compareDashboards: any[];
  dashboards: any[];
  hasChangedMap: Record<string, any>;
  features: Record<string, any>;
  sharedTabs: any[];
  init: typeof tempDashboardActions.initAtComponent;
  remove: typeof tempDashboardActions.remove;
  removeCompareDashboard: typeof tabsActions.triggerRemoveTab;
  changeSaveDashboardPromptVisibility: typeof changeSaveDashboardPromptVisibility;
  toggleUpdatePopupVisible: typeof toggleUpdatePopupVisible;
  setActiveDashboardId: typeof setActiveDashboardId;
  activeId?: string | number;
  renderSharedTab?: (styles: any) => React.ReactNode;
}

const selector = createSelector(
  dashboardListSelector,
  hasChangedMapSelector,
  compareTabsSelector,
  sharedTabsSelector,
  commonSelector,
  (dashboards, hasChangedMap, compareDashboards = [], sharedTabsStore, commonStore) => ({
    compareDashboards,
    dashboards,
    hasChangedMap,
    features: commonStore.features,
    sharedTabs: sharedTabsStore.tabs,
  }),
);

const TemporaryDashboardTabsWrapper: React.FC<ReduxProps> = (props) => {
  return React.createElement(TemporaryDashboardTabs as any, {
    ...props,
  });
};

export default connect(selector, {
  init: tempDashboardActions.initAtComponent,
  remove: tempDashboardActions.remove,
  removeCompareDashboard: tabsActions.triggerRemoveTab,
  changeSaveDashboardPromptVisibility,
  toggleUpdatePopupVisible,
  setActiveDashboardId,
})(TemporaryDashboardTabsWrapper);
